import Hammer from 'hammerjs';
import helpers from './helpers.js';
/*
=================================================================
GRID TO CAROUSEL
=================================================================
*/
export default (function () {
  return {
    init() {
      const carousels = document.querySelectorAll('.js-carousel, .js-carousel-mobile');
      const navMarkup = '<div class="js-carousel-nav carousel__nav"></div>';
      const controlsMarkup = '<div class="carousel__controls"><a href="#" data-ga-cat="carousel" data-ga-action="prev" class="carousel__control carousel__control--left js-carousel-prev">Previous</a> <a href="#" data-ga-cat="carousel" data-ga-action="next" class="carousel__control carousel__control--right js-carousel-next">Next</a></div>';
      let removedDownloads = false;
      let storedItem = [];
      let OmitedCarousel;

      if (!carousels.length) return;

      [...carousels].forEach((carousel, index) => {
        const isMobileOnly = carousel.classList.contains('js-carousel-mobile');
        const gridClass = isMobileOnly ? 'grid--inline@s' : 'grid--inline';
        const itemClass = isMobileOnly ? 'g-unit--inline@s' : 'g-unit--inline';
        const wrapperClass = isMobileOnly ? 'clip-outside@s' : 'clip-outside';
        const items = carousel.querySelectorAll('.g-unit:not(.js-accordion-exclude)');
        // if its only 1 item don't do anything
        if (items.length === 1) return;
        helpers.addClass(carousel, gridClass);
        const duplicateControls = carousel.previousElementSibling != null && carousel.previousElementSibling.querySelector('.js-add-controls') != null;
        const prevSibling = carousel.previousElementSibling;
        helpers.addClass(items, itemClass);
        helpers.removeClass(items, 'hover-up');
        if (duplicateControls) {
          helpers.addClass(carousel, 'has-duplicate-controls');
          carousel.previousElementSibling.querySelector('.js-add-controls').insertAdjacentHTML('beforeend', navMarkup + controlsMarkup);
        }


        // wrap functionality

        const el = carousel.closest('.wrapper');
        const wrapper = document.createElement('div');
        wrapper.className = wrapperClass;
        helpers.wrap(el, wrapper);
        const firstItemNotOmited = carousel.querySelector('.g-unit:not(.js-accordion-exclude)');
        helpers.addClass(firstItemNotOmited, 'is-current');

        carousel.closest('.wrapper').insertAdjacentHTML('beforeend', navMarkup);

        if (!isMobileOnly) {
          carousel.closest('.wrapper').insertAdjacentHTML('beforeend', controlsMarkup);
        }

        // Any items we want to be in a different grid on mobile and not in the carousel
        if (carousel.querySelectorAll('.js-accordion-exclude').length) {
          const clipSel = `.${wrapperClass}`.replace('@', '\\@');
          const clipEl = carousel.closest(clipSel);

          clipEl.insertAdjacentHTML('afterend', '<div class="wrapper wrapper--pad-l wrapper--flush-t u-hide@m u-hide@l"><div class="grid"></div></div>');
          [...carousel.querySelectorAll('.js-accordion-exclude')].forEach((item, i) => {
            const clone = item.cloneNode(true);
            clipEl.nextElementSibling.querySelector('.grid').appendChild(clone);
            item.classList.add('u-hide@s');
          });
        }

        function OmitDownloads() {
          if (carousel.querySelector('.g-unit:first-child').classList.contains('js-accordion-exclude') && helpers.breakpoint() === 'mobile') {
            storedItem.push(carousel.querySelector('.g-unit:first-child').cloneNode(true));
            removedDownloads = true;
            carousel.querySelector('.g-unit:first-child').remove();
            OmitedCarousel = carousel;
          }

          if (helpers.breakpoint() !== 'mobile' && storedItem.length) {
            console.log(storedItem[0]);
            OmitedCarousel.prepend(storedItem[0]);
            storedItem = [];
          }
        }

        OmitDownloads();


        function reposition() {
          // don't do anything if were not on mobile if only mobile carousel
          if (helpers.breakpoint() !== 'mobile' && carousel.classList.contains('js-carousel-mobile')) {
            helpers.removeClass(items, 'no-focus');
            helpers.removeAttribute(carousel.querySelectorAll('.g-unit, .g-unit a'), 'tabIndex');
            const offVal = 'none';
            helpers.setStyle(carousel, 'msTransform', offVal);
            helpers.setStyle(carousel, 'webkitTransform', offVal);
            helpers.setStyle(carousel, 'mozTransform', offVal);
            helpers.setStyle(carousel, 'transform', offVal);

            return;
          }

          let i = helpers.indexInParent(carousel.querySelector('.is-current'));
          // we do this because jQuery width will round the value. We don't want that.
          const actualWidth = carousel.querySelector('.g-unit').getBoundingClientRect().width;
          // figure out how many cols at this screen width
          const cols = Math.floor(carousel.closest('.wrapper').offsetWidth / actualWidth);
          const end = items.length - cols;

          if (i > items.length - cols && items.length - cols >= 0) {
            i = items.length - cols;
            helpers.removeClass(carousel.querySelector('.is-current'), 'is-current');
            helpers.addClass(items.item(i), 'is-current');
          }

          const gutter = parseInt(getComputedStyle(carousel.querySelector('.g-unit')).marginRight, 10) * 2;

          const off = (actualWidth + gutter) * i;
          const offVal = `translateX(-${off}px)`;

          helpers.addClass(items, 'no-focus');
          helpers.setAttributes(items, { tabIndex: '-1' });
          helpers.setAttributes(carousel.querySelectorAll('.g-unit a'), { tabIndex: '-1' });

          helpers.setStyle(carousel, 'msTransform', offVal);
          helpers.setStyle(carousel, 'webkitTransform', offVal);
          helpers.setStyle(carousel, 'mozTransform', offVal);
          helpers.setStyle(carousel, 'transform', offVal);

          // do we need to hide the controls?
          // const nextCtrl = carousel.closest('[class*=clip-outside]').querySelector('.carousel__next');
          // const prevCtrl = carousel.closest('[class*=clip-outside]').querySelector('.carousel__previous');
          const clip = carousel.closest('[class*=clip-outside]');
          const controls = clip.querySelector('.carousel__controls');

          if (controls != null) {
            if (items.length <= cols) {
              helpers.addClass(controls, 'u-hide');
              helpers.removeClass(clip, 'has-controls');
              if (duplicateControls) {
                const otherControls = carousel.parentElement.previousElementSibling.querySelector('.js-add-controls').querySelector('.carousel__controls');
                helpers.addClass(otherControls, 'u-hide');
              }
              clip.classList.add('no-controls');
            } else {
              helpers.removeClass(controls, 'u-hide');
              clip.classList.remove('no-controls');
              helpers.addClass(clip, 'has-controls');
              if (duplicateControls) {
                const otherControls = carousel.parentElement.previousElementSibling.querySelector('.js-add-controls').querySelector('.carousel__controls');
                helpers.removeClass(otherControls, 'u-hide');
              }
            }

            // do we need to disable the prev and next?
            const controlsLinks = carousel.closest('[class*=clip-outside]').querySelectorAll('.js-carousel-prev, .js-carousel-next');

            [...controlsLinks].forEach((ctrl) => {
              ctrl.classList.remove('is-disabled');
            });

            if (i >= end) {
              carousel.closest('[class*=clip-outside]').querySelector('.js-carousel-next').classList.add('is-disabled');
            }

            if (i === 0) {
              carousel.closest('[class*=clip-outside]').querySelector('.js-carousel-prev').classList.add('is-disabled');
            }
          }

          for (let n = 0; n < cols; n++) {
            if (items.item(i + n) == null) return;
            helpers.removeClass(items.item(i + n), 'no-focus');
            helpers.removeAttribute(items.item(i + n), 'tabIndex');
            helpers.removeAttribute(items.item(i + n).querySelectorAll('a'), 'tabIndex');
          }
        }
        reposition();

        const hammer = new Hammer(carousel.parentNode, {
          domEvents: true,
        });

        function createNav() {
          const count = items.length;
          let html = '';
          for (let i = 0; i < count; i++) {
            html += `<span href="#" class="js-carousel-nav-item">${i + 1}</span>`;
          }
          carousel.closest('.wrapper').querySelector('.js-carousel-nav').innerHTML = html;
          // console.log(carousel.closest('.wrapper'));
        }

        createNav();

        function updateNav(i) {
          const dots = carousel.closest('.wrapper').querySelectorAll('.js-carousel-nav .js-carousel-nav-item');
          // console.log(dots);
          helpers.removeClass(dots, 'is-active');
          helpers.addClass(dots[i], 'is-active');
        }

        updateNav(0);

        function goto(i) {
          if (i >= items.length || i < 0) {
            return;
          }
          const currentCard = carousel.querySelector('.is-current');
          helpers.removeClass(currentCard, 'is-current');
          helpers.addClass(items.item(i), 'is-current');
          reposition();
          // console.log('updating nav', i);
          updateNav(i);
        }

        function dotsMove() {
          const dots = carousel.closest('.wrapper').querySelectorAll('.js-carousel-nav .js-carousel-nav-item');

          [...dots].forEach((dot, i) => {
            dot.addEventListener('click', (e) => {
              goto(i);
            });
          });
        }

        dotsMove();

        function move(dir = 'next') {
          const currentCard = carousel.querySelector('.is-current');
          const len = items.length;
          let i = helpers.indexInParent(currentCard);

          if (dir === 'prev') {
            if (i - 1 < 0) return;
            i -= 1;
            // i = i < 0 ? 0 : i;
          } else {
            if (i + 1 >= len) return;
            i += 1;
          }

          goto(i);
          // reposition();
        }

        carousel.addEventListener('swiperight', (e) => {
          e.preventDefault();
          move('prev');
        });

        carousel.addEventListener('swipeleft', (e) => {
          e.preventDefault();
          move('next');
        });

        if (!isMobileOnly) {
          carousel.closest('[class*=clip-outside]').querySelector('.js-carousel-prev').addEventListener('click', (e) => {
            e.preventDefault();
            move('prev');
          });

          carousel.closest('[class*=clip-outside]').querySelector('.js-carousel-next').addEventListener('click', (e) => {
            e.preventDefault();
            move('next');
          });
        }

        if (duplicateControls && !isMobileOnly) {
          prevSibling.querySelector('.js-carousel-prev').addEventListener('click', (e) => {
            e.preventDefault();
            move('prev');
          });

          prevSibling.querySelector('.js-carousel-next').addEventListener('click', (e) => {
            e.preventDefault();
            move('next');
          });
        }

        window.addEventListener('resize', (e) => {
          // temporarily disable the transitions
          const grid = carousel.querySelector('.grid') || carousel;
          helpers.setStyle(grid, 'transition', 'none');
          OmitDownloads();
          reposition();

          // re-enable after positioning
          setTimeout(() => {
            helpers.setStyle(grid, 'transition', '');
          }, 10);
        });

        carousel.addEventListener('click', (e) => {
          if (e.target.matches('.no-focus') || e.target.closest('.no-focus') !== null) {
            e.preventDefault();
            e.stopPropagation();
            const card = e.target.matches('.no-focus') ? e.target : e.target.closest('.no-focus');
            const cardIndex = helpers.indexInParent(card);
            const currentCard = carousel.querySelector('.is-current');
            const currentCardIndex = helpers.indexInParent(currentCard);
            if (cardIndex > currentCardIndex) {
              move('next');
            } else {
              move('prev');
            }
          }
        });
      });
    },
  };
}());